export const PURCHASE_TYPE_ONLINE_CASHBACK = 1;
export const PURCHASE_TYPE_OFFLINE_CASHBACK = 41;
export const PURCHASE_TYPE_EBON_CASHBACK = 47;
export const PURCHASE_TYPE_REMAINING_POOL = 48;
export const PURCHASE_TYPE_CUSTOMER_SERVICE_REGULARIZATION = 53;
export const PURCHASE_TYPE_GIVEAWAY_BONUS = 56;



// WEBPACK FOOTER //
// ./src/constants/purchase.js